export default __webpack_public_path__ + "static/media/glenn.c7b40642.jpg";